import React from "react";
import ContentContainer from "../../../../../components/common/content-container";
import FilterBar from "../../../../common/filter-bar";
import BookCard from "../../../../common/book-card";
import { useTranslation } from "react-i18next";

const AudioBooks = (props) => {
  const { t } = useTranslation();

  return (
    <div className="container text-justify">
      <div className="container text-relevant">
        <h1>{t("audiobooks")}</h1>
      </div>

      <FilterBar
        stateHandler="literatureFilter"
        actionType={props.filterActionType}
        searchFunction={props.getBooks}
      />
      <div>
        <ContentContainer
          get={props.getBooks}
          reducer={props.literatureBooks}
          content={(data) => <BookCard key={data.id} book={data}></BookCard>}
        />
      </div>
    </div>
  );
};

export default AudioBooks;
